import 'owl.carousel';

export function sliders()
{
		let sliders = $('.slider');

		sliders.each(function(){
				//Change the options here - you can use data-* tags to specify different values for different sliders
				let options = {
					items: 1,
					dots: false,
					nav: true,
					autoplayTimeout: 3000,
					loop: true,
					smartSpeed: 1000,
					onTranslated: function(event) {
						let active_slide = $('.slider').find('.active');
						let index = active_slide.find('.project__slide-image').attr('data-index');
						console.log(index);
						$('span.counter__number').html(index);
					},
					responsive: {
						0: {
							autoplay: false,
							autoplayHoverPause: false,
						},
						900: {
							autoplay: true,
							autoplayHoverPause: true,
						},
					},
				};

				$(this).owlCarousel(options);
		})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js